import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { RepositoryformComponent } from "../repositoryform/repositoryform.component";
import { DaoService } from "src/app/services/dao.service";
import { LstorageService } from "src/app/services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { DomSanitizer } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-repository",
  templateUrl: "./repository.component.html",
  styleUrls: ["./repository.component.scss"],
})
export class RepositoryComponent implements OnInit {
  fileUrl: any;
  fileList: any;
  folderName: any;
  public shown = {
    grid: true,
    Form: false,
  };

  public fshown = {
    folder: true,
    file: false,
  };

  public validator = {
    errorMessage: "",
    UniqueRepository: false,
  };

  Repository = new FormGroup({
    userId: new FormControl(),
    folderName: new FormControl(),
  });
  RepositoryData: any;
  userId: any;

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private daoService: DaoService,
    private token: LstorageService,
    private spinner: SpinnerService,
    private sanitizer: DomSanitizer
  ) {
    console.log("constructor");
    this.validator.UniqueRepository = false;
    var user = jwtDecode(this.token.getToken());
    this.userId = user.unique_name;
    this.spinner.show();
    this.daoService.getRepositoryById(this.userId).subscribe(
      (data: any) => {
        this.RepositoryData = data;
        this.spinner.hide();
      },
      (err) => {
        console.log(err), this.spinner.hide();
      }
    ); // If got an error);
  }
  ngOnInit() {}

  openDialog(): void {
    const dialogRef = this.dialog.open(RepositoryformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "375px",
      height: "auto",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {});
  }

  onView(fileId) {
    this.spinner.show();
    this.daoService.onView(fileId).subscribe(
      (blob: any) => {
        const objectURL = URL.createObjectURL(blob);
        this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        const url = URL.createObjectURL(blob);
        this.spinner.hide();
        window.open(url, "_blank");
      },
      (err) => {
        console.log(err), this.spinner.hide();
      }
    );
    this.spinner.hide();
  }

  fileView(folderName) {
    this.spinner.show();
    this.daoService.fileView(this.userId, folderName).subscribe(
      (data: any) => {
        this.fileList = data;
        this.folderName = folderName;
        this.fshown.folder = false;
        this.fshown.file = true;
        this.spinner.hide();
      },
      (err) => {
        console.log(err), this.spinner.hide();
      }
    );
  }

  backToTemplate() {
    this.fshown.folder = true;
    this.fshown.file = false;
  }
}
